var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.55 43.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.28,0l15.54,37.95L37.26,0h6.29v43.28h-4.26V5.87h-.14l-15.31,37.41h-4.02L4.39,5.89h-.13v37.41H0V0h6.28Z",
    fill: "#e32636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMVector);
export default __webpack_public_path__ + "static/media/MVector.0b30695aea93988506e6c46ea4c9b722.svg";
export { ForwardRef as ReactComponent };